import dayjs from 'dayjs';

const getDefaultPagination = (currentPage = 1, perPage = 10, totalRows = 0) => {
    return {
        currentPage: currentPage,
        perPage: perPage,
        totalRows: totalRows
    };
};

const getPerPageOptions = () => {
    return [
        {text: '10개', value: 10},
        {text: '20개', value: 20},
        {text: '30개', value: 30},
        {text: '50개', value: 50},
        {text: '100개', value: 100},
    ];
};

const getEmptyTableHTML = (text) => {
    return `<div class="text-center text-muted d-flex flex-column justify-content-center align-items-center" style="height: 521px;">
                <i class="bi bi-exclamation-circle-fill" style="font-size: 2rem;"></i>
                <h6 class="mt-3 gray-400">${text}</h6>
            </div>`;
};

const onTooltipShow = (bvEvent) => {
    const targetEl = bvEvent.target;
    
    const tooltip = bvEvent.vueTarget;
    if (!tooltip) return;
    
    const width = targetEl.offsetWidth;
    tooltip.offset = -(width / 2);
};

const getDate = (date) => {
    if (!date) return '';
    if (!dayjs(date).isValid()) return '잘못된 날짜 형식입니다.';
    return dayjs(date).format('YYYY-MM-DD HH:mm:ss');
};


const getProjectCodeOptions = (projects) => {
    if (projects == null || projects.length === 0) {
        return [];
    }
    const mapOptions = {};
    projects.forEach(item => {
        if (item.period?.[0] == null || item.period?.[0] === '')
            return;
        if (mapOptions[item.period] == null) {
            mapOptions[item.period] = [];
        }
        const copyProjects = JSON.parse(JSON.stringify(item.projects));
        copyProjects.sort((a, b) => b.id - a.id);
        copyProjects.forEach(project => {
            mapOptions[item.period].push({
                value: project,
                text: `${project.project_code} - ${project.client} (${project.id})`,
                id: project.id
            });
        });
        
    });
    const result = Object.entries(mapOptions).reduce((acc, [key, value]) => {
        acc.push({
            group: key,
            items: value
        });
        return acc;
    }, []);
    result.sort((a, b) => {
        return b.group.localeCompare(a.group);
    });
    return result;
};

const getCampaignOptions = (campaigns) => {
    if (campaigns == null || campaigns.length === 0) {
        return [];
    }
    return campaigns.reduce((acc, cur) => {
        acc.push({
            value: cur,
            text: `${cur.campaign_name} (${cur.campaign_id})`,
            id: cur.campaign_id
        });
        return acc;
    }, []);
};

const getTargetProjectText = (projectId, projects, withClient = true) => {
    if (projectId == null || projects == null || projects.length === 0) {
        return null;
    }
    
    let targetProject = null;
    for (let i = 0; i < projects.length; i++) {
        targetProject = projects[i].projects.find(item => item.id === projectId);
        if (targetProject) {
            if (withClient) {
                return `${targetProject.project_code} - ${targetProject.client} (${targetProject.id})`;
            }
            else {
                return `${targetProject.project_code} (${targetProject.id})`;
            }
        }
    }
    return null;
};

const getTargetCampaignText = (campaignId, campaigns) => {
    const target = campaigns?.find(item => {
        return item.campaign_id === campaignId;
    });
    
    if(target){
        return `${target.campaign_name} (${target.campaign_id})`;
    }
    return null;
};

export {
    getDefaultPagination,
    getPerPageOptions,
    getEmptyTableHTML,
    onTooltipShow,
    getDate,
    getProjectCodeOptions,
    getCampaignOptions,
    getTargetProjectText,
    getTargetCampaignText
};
